//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/index.js
//
//  This file is the 'start' javascript file called from 'index.html'.
//
//  Run:
//  Note: To run this code, type "npm start" in the command line 
//  when in the "C:\Users\person\www\CityBiz\frontend" directory.
//

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import CityBiz from './containers/CityBiz';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<CityBiz />, document.getElementById( 'root' ));

//  Note: "The service worker is a web API that heps you cache your assets and
//  other files so that when the user is offline or on a slow network, he/she 
//  can still see results on the screen.  As such, it helps you build a better
//  user experience.  (It is all about adding offline capabilities to your site.)"
//
//  Note: I also read where it is only valid on 'secure origins' or 'HTTPS' type ports.
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js